import Http from "@services/http";
import BaseApi from "@api/base.api";

export default class FileApi extends BaseApi {
    static get entity() {
        return 'files'
    }

    static async upload(data) {
        return await Http.request(data)
    }

    static async getRelatedFiles(data) {
        return this.get(data);
    }
}
